import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import FetchingStatus from 'constants/statuses/FetchingStatus';

export type Hotel = { id: number; name: string; isOnline: boolean };
export type HotelsState = {
  fetching: FetchingStatus | null;
  value: Hotel[] | null;
  selected: Hotel | null;
  includeOffline: boolean;
  hotelSearch: Hotel[];
  hotelSearchFetching: FetchingStatus | null;
};

const initialState: HotelsState = {
  fetching: null,
  value: null,
  selected: null,
  includeOffline: false,
  hotelSearch: [],
  hotelSearchFetching: null,
};

function setHotelValueFunction(state: HotelsState, action: PayloadAction<HotelsState['selected']>) {
  return {
    ...state,
    selected: action.payload,
  };
}

function setFetchingFunction(state: HotelsState, action: PayloadAction<HotelsState['fetching']>) {
  return {
    ...state,
    fetching: action.payload,
  };
}

function setHotelsFunction(state: HotelsState, action: PayloadAction<HotelsState['value']>) {
  return {
    ...state,
    value: action.payload,
  };
}

function setHotelsIncludeOfflineFunction(state: HotelsState, action: PayloadAction<HotelsState['includeOffline']>) {
  return {
    ...state,
    includeOffline: action.payload,
  };
}

function setHotelsBySearchFunction(state: HotelsState, action: PayloadAction<HotelsState['hotelSearch']>) {
  return {
    ...state,
    hotelSearch: action.payload,
  };
}

function setHotelsBySearchFetchingFunction(
  state: HotelsState,
  action: PayloadAction<HotelsState['hotelSearchFetching']>
) {
  return {
    ...state,
    fetching: action.payload,
  };
}

const slice = createSlice({
  name: 'hotelManager.hotels',
  initialState,
  reducers: {
    setFetching: setFetchingFunction,
    setHotels: setHotelsFunction,
    setHotelValue: setHotelValueFunction,
    setHotelsIncludeOffline: setHotelsIncludeOfflineFunction,
    setHotelsBySearch: setHotelsBySearchFunction,
    setHotelsBySearchFetching: setHotelsBySearchFetchingFunction,
  },
});

export const {
  setFetching,
  setHotels,
  setHotelValue,
  setHotelsIncludeOffline,
  setHotelsBySearch,
  setHotelsBySearchFetching,
} = slice.actions;
export default slice.reducer;
